<script lang="ts" setup>
import { computed } from "vue";
import type { InputDensity, InputHideDetails, InputVariant } from "@/types/props";

defineSlots<{
  prepend(): unknown;
  append(): unknown;
  "prepend-inner"(): unknown;
  "append-inner"(): unknown;
}>();

const props = withDefaults(
  defineProps<{
    id?: string;
    modelValue?: string | number | undefined;
    label?: string;
    rules?: Array<any>;
    required?: boolean;
    disabled?: boolean;
    autocomplete?: string;
    color?: string;
    density?: InputDensity;
    hideDetails?: InputHideDetails;
    variant?: InputVariant;
    width?: string | number;
    placeholder?: string;
  }>(),
  {
    modelValue: "",
    label: "",
    rules: () => [],
    required: false,
    disabled: false,
    autocomplete: "off",
    color: "primary",
    density: "compact",
    hideDetails: "auto",
    variant: "outlined",
    width: undefined,
    placeholder: "",
  },
);

const emit = defineEmits(["update:modelValue"]);

const model = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit("update:modelValue", value);
  },
});
</script>

<template>
  <v-text-field
    :id="props.id"
    v-model="model"
    :autocomplete="props.autocomplete"
    :class="{ required: props.required }"
    :color="props.color"
    :density="props.density"
    :disabled="props.disabled"
    :hide-details="props.hideDetails"
    :label="props.label"
    :placeholder="props.placeholder"
    :rules="props.rules"
    :variant="props.variant"
    :width="props.width"
    class="omni-text-field"
    flat
  >
    <template #prepend-inner>
      <slot name="prepend-inner" />
    </template>
    <template #append-inner>
      <slot name="append-inner" />
    </template>
  </v-text-field>
</template>

<style lang="scss" scoped>
@import "@/assets/style/color";

.omni-text-field {
  &:deep(.v-field--variant-solo) {
    input::placeholder {
      opacity: 1;
    }
  }
}

.v-input--density-compact {
  &:deep(input) {
    padding: 10px 8px;
  }
}
</style>
